<template>
    <div class="container">
        <b-modal
            :model-value="showDialogGrupo"
            :no-close-on-backdrop="true"
            hide-footer
                        centered
            :title="labels.createGroup"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-grupo-dialog"
         @hide="clicked">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="nuevoGrupo.nombre" 
                            type="text" 
                            class="form-input" 
                            autocomplete="off"
                            placeholder="Nombre del grupo"
                            @blur="validateField('nombre')"
                        />
                        <span class="error-message" v-if="errors?.nombre">{{ errors?.nombre }}</span>
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary ml-2" @click="crearGrupo" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Grupo from '@/services/Grupo'

export default {
    name: "NewGrupo",
    props: ['showDialogGrupo'],
    data: () => ({
        nuevoGrupo: {
            nombre: ""
        },
        errors: {
            nombre: ""
        },
        isLoading: false
    }),
    watch: {
        showDialogGrupo(val) {
            if (val) {
                this.resetForm()
            }
        }
    },
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    createGroup: "Crear Grupo",
                    name: "Nombre",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Nuevo grupo",
                    infoText: "Completa la información para crear un nuevo grupo."
                }
            } else {
                return {
                    createGroup: "Create Group",
                    name: "Name",
                    save: "Save",
                    close: "Close",
                    infoTitle: "New group",
                    infoText: "Complete the information to create a new group."
                }
            }
        }
    },
    methods: {
        resetForm() {
            this.nuevoGrupo = { nombre: "" }
            this.errors = { nombre: "" }
        },
        validateField(field) {
            const lang = this.$store.state._language
            
            if (field === 'nombre') {
                if (!this.nuevoGrupo.nombre) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre del grupo es obligatorio" 
                        : "Group name is required"
                } else if (this.nuevoGrupo.nombre.length < 3) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre debe tener al menos 3 caracteres" 
                        : "Name must have at least 3 characters"
                } else if (this.nuevoGrupo.nombre.length > 255) {
                    this.errors.nombre = lang == "es-ES" 
                        ? "El nombre no puede exceder los 255 caracteres" 
                        : "Name cannot exceed 255 characters"
                } else {
                    this.errors.nombre = ""
                }
            }
        },
        validateForm() {
            this.validateField('nombre')
            return !this.errors.nombre
        },
        async crearGrupo() {
            if (!this.validateForm()) {
                this.$toast.error(this.$store.state._language == "es-ES" 
                    ? "Por favor, corrija los errores del formulario" 
                    : "Please correct the form errors")
                return
            }
            
            this.isLoading = true
            try {
                const userData = {
                    ...this.nuevoGrupo,
                    u_crea: this.$store.state.userId
                }
                
                const res = await Grupo.create(userData)
                
                this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                    ? "Grupo creado exitosamente" 
                    : "Group created successfully"))
                
                this.resetForm()
                this.$emit('clicked', false)
                this.$emit('grupoCreado')
                
            } catch (error) {
                console.error("Error creating group:", error)
                
                let errorMessage = this.$store.state._language == "es-ES" 
                    ? "Error al crear el grupo" 
                    : "Error creating group"
                
                if (error.response && error.response.data) {
                    if (error.response.data.message) {
                        errorMessage = error.response.data.message
                    } else if (error.response.data.error) {
                        errorMessage = error.response.data.error
                    }
                }
                
                this.$toast.error(errorMessage)
            } finally {
                this.isLoading = false
            }
        },
        clicked() {
            this.resetForm()
            this.$emit('clicked', false)
        }
    }
}
</script>

<style src="../main.css"></style>